import { render, staticRenderFns } from "./SetCombo.vue?vue&type=template&id=50333192&"
import script from "./SetCombo.vue?vue&type=script&lang=js&"
export * from "./SetCombo.vue?vue&type=script&lang=js&"
import style0 from "./SetCombo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports